import { useSelector } from 'react-redux'

import { getIsFilterUnfinalizedSoapFromMedicalRecordsEnabled } from '~/store/reducers/constants'

export const useSoapMenuReportCard = () => {
  const isFilterUnfinalizedSoapFromMedicalRecordsEnabled = useSelector(
    getIsFilterUnfinalizedSoapFromMedicalRecordsEnabled,
  )

  return {
    showReportCard: !isFilterUnfinalizedSoapFromMedicalRecordsEnabled,
  }
}
